import { render, staticRenderFns } from "./logo-page.vue?vue&type=template&id=04b81e26&lang=pug&"
import script from "./logo-page.vue?vue&type=script&lang=js&"
export * from "./logo-page.vue?vue&type=script&lang=js&"
import style0 from "./logo-page.vue?vue&type=style&index=0&id=04b81e26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports